// English translations
export default {
  // Navbar
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.services': 'Services',
  'nav.transformations': 'Transformations',
  'nav.feedback': 'Feedback',
  'nav.packages': 'Packages',
  'nav.faq': 'FAQ',
  'nav.contact': 'Contact Us',
  
  // Landing
  'landing.title.accent': 'NOT JUST ONLINE TRAINING',
  'landing.title.text': 'IT\'S A JOURNEY TO CHANGE YOUR BODY, MINDSET & HABITS',
  'landing.subtitle': ' ',
  'landing.cta.start': 'Start Transformation →',
  'landing.cta.view': 'View Programs ↓',
  'landing.video.title': 'My Coaching Services',
  'landing.video.subtitle': 'Learn how I can help you achieve your fitness goals',
  'landing.video.cta': 'Click to play',
  'landing.video.hint.personalized': 'Personalized Coaching Programs',
  'landing.video.hint.hd': 'HD',
  'landing.video.hint.service': 'Service Overview',
  'landing.video.caption.personalized': 'Personalized Coaching Programs',
  'landing.video.caption.watch': 'Watch more',
  'landing.video.caption.stories': 'View Transformations',
  
  // About
  'about.title': 'About',
  'about.me': 'Me',
  'about.description': 'I provide you with all online training services based on scientific principles with the highest possible quality',
  'about.qualification.1': 'Physical Therapy Student',
  'about.qualification.2': 'Certified Personal Trainer',
  'about.qualification.3': 'Sports Nutrition Specialist certified by the American Board',
  'about.qualification.4': 'Content Creator across all social media platforms',
  'about.certified_coach': 'Certified Coach',
  'about.image_alt': 'Professional Coach',
  
  // Services
  'services.title': 'Why Dr Fares',
  'services.subtitle': '',
  'services.diet.title': 'Training',
  'services.diet.description': '',
  'services.diet.feature.1': 'Science-based training schedule customized for you',
  'services.diet.feature.2': 'Exercise swap tool so changing gyms won\'t affect you',
  'services.diet.feature.3': 'Dr Fares explanation videos for every exercise',
  'services.diet.feature.4': 'Gym or home training schedules as needed',
  'services.workout.title': 'Diet',
  'services.workout.description': '',
  'services.workout.feature.1': 'Diet suited to your day, lifestyle & budget',
  'services.workout.feature.2': 'Food swap tool for variety and less boredom',
  'services.workout.feature.3': 'Same-calorie alternatives to maintain consistency',
  'services.tools.title': 'Real Follow-up',
  'services.tools.description': '',
  'services.tools.feature.1': 'Step-by-step guidance so you understand yourself',
  'services.tools.feature.2': 'Solving any problem you face to fix your habits',
  'services.tools.feature.3': 'Regular check-ins to ensure your consistency',
  'services.cta.view': 'View Packages',
  'services.cta.looking': 'Looking for a customized program that doesn\'t fit these categories?',
  
  // Transformations
  'transformations.title': 'Transformations',
  'transformations.subtitle': 'Real results from real clients who followed the program',
  'transformations.before': 'Before',
  'transformations.after': 'After',
  'transformations.read.more': 'Read more',
  'transformations.read.less': 'Read less',
  'transformations.stats.title': 'Transformation Stats',
  'transformations.stats.weight': 'Weight Loss',
  'transformations.stats.bodyfat': 'Body Fat Reduction',
  'transformations.client.1.name': 'Yousef Al-Nazer',
  'transformations.client.1.role': 'Student & Working Full Time',
  'transformations.client.1.duration': '3 months',
  'transformations.client.1.achievement': 'Muscle Gain with Minimal Fat',
  'transformations.client.1.story': 'A third-year nursing student who works in a pharmacy for about 7 hours daily, dealing with scapular winging. Despite these challenges, we managed to create schedules that fit his daily routine, helping him gain 6kg of pure muscle. He\'s still continuing his journey to reach the best version of himself.',
  'transformations.client.2.name': 'Fares Mosaad',
  'transformations.client.2.role': 'Engineering Student',
  'transformations.client.2.duration': '2 months',
  'transformations.client.2.achievement': 'Fat Loss While Preserving Muscle',
  'transformations.client.2.story': 'As an engineering student, most of his day is spent in lectures and sitting in uncomfortable positions for long periods, which caused rounded shoulders. Despite the time constraints from lectures and studies, he managed to lose 8kg of fat in 2 months and is still continuing because he wants to reach the best version of himself',
  
  // Feedback
  'feedback.title': 'Feedbacks',
  'feedback.subtitle': 'What our clients say about us',
  'feedback.ariaLabel.gallery': 'Client testimonials gallery',
  'feedback.ariaLabel.prevButton': 'View previous testimonials',
  'feedback.ariaLabel.nextButton': 'View more testimonials',
  'feedback.ariaLabel.viewImage': 'View testimonial image',
  'feedback.navigation.instructions': 'Use left and right arrow keys to navigate through the testimonial images. Press Enter on an image to view it in full screen.',
  'feedback.error.loadingImage': 'Failed to load image',
  'feedback.announcement.left': 'Scrolled left',
  'feedback.announcement.right': 'Scrolled right',
  
  // Packages
  'packages.title': 'Pricing Packages',
  'packages.subtitle': 'Choose the plan that fits your goals and lifestyle',
  'packages.features': 'All features include:',
  'packages.tier': 'Choose your tier:',
  'packages.cta': 'Get Started',
  'packages.bestvalue': 'Best Value',
  'packages.popular': 'POPULAR',
  'packages.free_consultation': 'All packages include a free initial consultation',
  'packages.contact_us': 'Contact Us',
  'packages.discount': '50% OFF',
  'packages.installment': 'Pay in 2 installments',
  'packages.egp': 'EGP',
  'packages.usd': 'USD',
  'packages.sar': 'SAR',
  'packages.aed': 'AED',
  'packages.kwd': 'KWD',
  'packages.qar': 'QAR',
  'packages.bhd': 'BHD',
  'packages.omr': 'OMR',
  'packages.jod': 'JOD',
  'packages.lbp': 'LBP',
  'packages.iqd': 'IQD',
  'packages.syp': 'SYP',
  'packages.yer': 'YER',
  'packages.ils': 'ILS',
  'packages.mad': 'MAD',
  'packages.dzd': 'DZD',
  'packages.tnd': 'TND',
  'packages.lyd': 'LYD',
  'packages.sdg': 'SDG',
  'packages.sos': 'SOS',
  'packages.djf': 'DJF',
  'packages.mro': 'MRO',
  'packages.get_plan': 'Get {0} Plan',
  'packages.testing.title': 'Trial Package',
  'packages.testing.duration': '1 Month + 1 Month Free',
  'packages.testing.suitableFor': 'Perfect if you have a simple goal or want to start with a trial.',
  'packages.development.title': 'Development Package',
  'packages.development.duration': '3 Months + 1 Month Free',
  'packages.development.suitableFor': 'Excellent if you want to start a real change and reach a clear goal.',
  'packages.journey.title': 'Journey Package',
  'packages.journey.duration': '6 Months + 1 Month Free',
  'packages.journey.suitableFor': 'Ideal if you want to disappear and return as a completely different person.',
  'packages.silver': 'Silver',
  'packages.gold': 'Gold',
  'packages.silver.benefit.1': 'Weekly WhatsApp follow-up',
  'packages.silver.benefit.2': 'Answers to questions as time permits',
  'packages.gold.benefit.1': 'Daily follow-up',
  'packages.gold.benefit.2': 'Priority response to questions',
  'packages.gold.benefit.3': 'Monthly video call based on client preference to track progress (men only)',
  'packages.feature.1': 'Training schedule based on your free time (home/gym)',
  'packages.feature.2': 'High-quality exercise links with detailed explanations',
  'packages.feature.3': 'Exercise substitution tool based on available equipment',
  'packages.feature.4': 'Detailed nutrition plan based on your favorite foods',
  'packages.feature.5': 'Food substitution tool for variety while sticking to your diet',
  'packages.feature.6': 'Postural correction for common issues (Winged Scapula, Rounded Shoulders)',
  'packages.feature.7': 'Instructional videos explaining the journey',
  'packages.feature.8': 'Diet tips guide',
  'packages.feature.9': 'Personalized supplement plan based on client preference',
  'packages.feature.10': 'Performance tracking through video submissions',
  
  // WhatsApp Messages
  'whatsapp.general': 'I\'m interested in learning more about your coaching services.',
  'whatsapp.package': 'I\'m interested in the {0} - {1} plan.',
  
  // FAQ
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Answers to common questions about our services and programs',
  'faq.more': 'Have more questions? We\'re here to help!',
  'faq.contact': 'Contact Us',
  'faq.q1': 'Who can join the program?',
  'faq.a1': 'Anyone who wants to transform their life and body to become a better version of themselves, provided they do not have any severe (injuries or medical conditions) that prevent them from exercising or following a diet without their doctor\'s approval',
  'faq.q2': 'Do you train women?',
  'faq.a2': 'Yes, with special arrangements for privacy. Communication can be done through a family member if preferred.',
  'faq.q3': 'How long does it take to receive the program?',
  'faq.a3': 'You\'ll receive your program within 1-3 days maximum.',
  'faq.q4': 'What\'s the refund policy?',
  'faq.a4': 'You can get a full refund if you haven\'t received any plans yet. However, once the program is delivered, refunds are not available.',
  'faq.q5': 'Is there follow-up and monitoring?',
  'faq.a5': 'Yes, the Silver package includes weekly follow-ups, while the Gold package offers daily monitoring.',
  'faq.q6': 'When does the subscription start?',
  'faq.a6': 'Your subscription begins as soon as you receive your workout schedules.',
  'faq.q7': 'Is it mandatory to share client transformations?',
  'faq.a7': 'While it\'s preferred, we respect client privacy. It\'s completely up to the client\'s preference.',
  
  // Footer
  'footer.rights': 'All rights reserved',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms',
  'footer.cookies': 'Cookies',
  'footer.connect': 'Connect With Us'
}; 